import { render, staticRenderFns } from "./BasicDetails.vue?vue&type=template&id=129720e9&"
import script from "./BasicDetails.vue?vue&type=script&lang=js&"
export * from "./BasicDetails.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetails.vue?vue&type=style&index=0&id=129720e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports